module.exports = __webpack_public_path__ + "static/media/Competitor.c8a2b27a.png";